// extracted by mini-css-extract-plugin
export default {"backdrop":"GridPreviewModal_backdrop__nsWt+","fadeIn":"GridPreviewModal_fadeIn__QhPQs","image":"GridPreviewModal_image__yRfiy","closeBtn":"GridPreviewModal_closeBtn__LtN1t"};